export default __webpack_public_path__ + "static/media/integrations-winkas.529c5818.png";